module.exports = __webpack_public_path__ + "static/media/logo.d35bf951.svg";